import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { Button } from 'components';

const Container = styled.div`
	z-index: 100;
	background-color: white;
	position: fixed;
	padding: 40px 20px;
	width: 100vw;
	height: 100vh;
	top: 0;
	left: 0;
	overflow-x: hidden;
	overflow-y: auto;
	border: 1px solid ${props => props.theme.inputBorderColor};
	box-shadow: 5px 5px 5px rgba(33, 33, 33, .3);
	display: flex;
	flex-direction: column;
	align-items: stretch;

	@media (min-width: 1280px) {
		padding: 20px;
		width: ${props => isNaN(Number(props.$width)) ? props.$width : `${props.$width}px`};
		height: auto;
		max-width: calc(100vw - 80px);
		max-height: calc(100vh - 80px);
		top: 50%;
		left: 50%;
		transform: translateX(-50%) translateY(-50%);
	}

	&.inner {
		padding: 20px 40px;
		width: calc(100vw - 40px);
		height: auto;
		max-width: calc(100vw - 40px);
		max-height: calc(100vh - 80px);
		top: 50%;
		left: 50%;
		transform: translateX(-50%) translateY(-50%);

		@media (min-width: 1280px) {
			padding: 20px 40px;
			width: ${props => isNaN(Number(props.$width)) ? props.$width : `${props.$width}px`};
			max-width: calc(100vw - 80px);
		}
	}

	> .buttonAsLink {
		position: absolute;
		top: 10px;
		right: 10px;
		z-index: 1000;
	}
`;

const Overlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: #004685CC;
	z-index: 100;
	display: block;
`;

const IconClose = () => (
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fillRule="evenodd" clipRule="evenodd" d="M0.50499 0.504989C1.17831 -0.168328 2.26997 -0.168328 2.94329 0.504989L19.495 17.0567C20.1683 17.73 20.1683 18.8217 19.495 19.495C18.8217 20.1683 17.73 20.1683 17.0567 19.495L0.50499 2.94329C-0.168328 2.26997 -0.168328 1.17831 0.50499 0.504989Z" fill="currentColor"/>
		<path fillRule="evenodd" clipRule="evenodd" d="M19.495 0.504988C20.1683 1.17831 20.1683 2.26997 19.495 2.94329L2.94329 19.495C2.26997 20.1683 1.17831 20.1683 0.504988 19.495C-0.168329 18.8217 -0.168329 17.73 0.504988 17.0567L17.0567 0.504988C17.73 -0.168329 18.8217 -0.168329 19.495 0.504988Z" fill="currentColor"/>
	</svg>
);

export const Portal = ({ isOpen = false, onClose = false, width = 560, className = '', style = {}, portalStyle = {}, children = null }) => {
	const el = useRef(document.createElement('div'));
	const root = document.getElementById('root');

	useEffect(() => {
		root.appendChild(el.current);
		return () => root.removeChild(el.current);
	}, []);

	const handleClose = () => (typeof onClose === 'function') && onClose();

	return isOpen
		? ReactDOM.createPortal(
			<>
				<Overlay onClick={handleClose} style={portalStyle} />

				<Container $width={width} className={`portal ${className}`} style={style}>
					{typeof onClose === 'function' &&
						<Button link onClick={handleClose}>
							<IconClose />
						</Button>
					}

					{children}
				</Container>
			</>, el.current
		)
		: null;
};
